import { render, staticRenderFns } from "./bottomLeft.vue?vue&type=template&id=bf99e63e&"
import script from "./bottomLeft.vue?vue&type=script&lang=js&"
export * from "./bottomLeft.vue?vue&type=script&lang=js&"
import style0 from "./bottomLeft.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports